export default "__VITE_ASSET__dce8121b__"